"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stun = exports.renderShadow = exports.diveCrew_shadows = exports.getSplatterType = exports.getSplatterTint = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var diveEnums_1 = require("@dive/enums/diveEnums");
var spritesCrew_1 = require("@dive/spriteRecyclers/spritesCrew");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var diveCrew_attackable_sidecar_1 = require("./diveCrew_attackable-sidecar");
var diveCrew_movable_sidecar_1 = require("./diveCrew_movable-sidecar");
function getSplatterTint(obj) {
    var splatterTint = diveColors_1.diveColors.red;
    if (obj.enemyState) {
        splatterTint = obj.enemyState.data.splatterTint;
    }
    return splatterTint;
}
exports.getSplatterTint = getSplatterTint;
function getSplatterType(obj) {
    var splatterType = diveEnums_1.EDiveSplatterType.Blood;
    if (obj.enemyState) {
        splatterType = obj.enemyState.data.splatterType;
    }
    return splatterType;
}
exports.getSplatterType = getSplatterType;
exports.diveCrew_shadows = [
    sprites_sidecar_1.sprites.diveEffectsMonsterShadow1[0],
    sprites_sidecar_1.sprites.diveEffectsMonsterShadow1[0],
    sprites_sidecar_1.sprites.diveEffectsMonsterShadow2[0],
    sprites_sidecar_1.sprites.diveEffectsMonsterShadow3[0],
];
var renderShadow = function (obj, renderShadow) {
    if (renderShadow) {
        var shadow = spritesCrew_1.spritesCrew.getNext(obj.x, obj.y, exports.diveCrew_shadows[renderShadow]);
        shadow.scaleX = obj.isFlipped ? -shadow.scaleX : shadow.scaleX;
        return shadow;
    }
    return null;
};
exports.renderShadow = renderShadow;
var stun = function (obj, duration) {
    if (obj.stunLeft < 0) {
        obj.stunLeft = 0;
    }
    diveCrew_movable_sidecar_1.diveCrew_movable.clearPath(obj);
    diveCrew_attackable_sidecar_1.diveCrew_attackable.interruptAttack(obj);
    obj.stunLeft += duration;
};
exports.stun = stun;
